<div class="widget-container">
  @if (!isOpen()) {
    <button class="widget-toggle" (click)="isOpen.set(true)">
      <i [name]="'chat'" thxIcons></i>
    </button>
  }

  @if (isOpen()) {
    <div class="widget-modal">
      <div class="widget-header">
        <span>{{theme | titlecase}} Travel Advisor
        <a [href]="homepageUrl" class="popout">
        <i nz-icon nzType="export" nzTheme="outline"></i>
        </a></span>
        <button class="close-btn" (click)="isOpen.set(false)">×</button>
      </div>
      <div class="widget-content">
        <chatbot-component [isWidgetMode]="true" />
      </div>
    </div>
  }
</div>
